module.exports = __webpack_public_path__ + "img/bear7.8599e14c.png";